import type { NotificationCollaborationProps } from '@/utils/hooks/context/toast/types';

// Components
import PostCommented from '@/components/composite/Notifications/Collaboration/PostCommented';
import PostStatusChanged from '@/components/composite/Notifications/Collaboration/PostStatusChanged';

const NotificationsCollaboration = ({ notification }: NotificationCollaborationProps) => {
    const type = notification.type;
    switch (type) {
        case 'collaboration_post_note_created':
            return <PostCommented notification={notification} />;
        case 'collaboration_post_status_updated':
            return <PostStatusChanged notification={notification} />;
        default:
            return null;
    }
};

export default NotificationsCollaboration;
